import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/appointment/importer/appointmentImporterActions'

export default importerReducers(actions)
